import React from 'react';

interface SpinnerProps {
  size?: number | string;
  color?: string;
}

const Spinner: React.FC<SpinnerProps> = ({ size = '50px', color = '#009be0' }) => {
  const sizeStr = typeof size === 'number' ? `${size}px` : size;
  return (
    <div
      className="spinner"
      style={{ width: sizeStr, '--spinner-color': color } as React.CSSProperties}
    />
  );
};

export default Spinner;
